import {
  BarChartData,
  BarChartLegend,
  BarGroupData
} from '../../shared/models/charts/chart-data-types';
import {
  trancheToTrancheGroup,
  TrancheGroup
} from '../../gameday/data/gameDay-data.transformations';
import {
  getLegendExtractor,
  getColorPartExtractor
} from '../../gameday/mappers/gameDay.extractors';
import { TrancheSummaryParams } from '../models/tranche-summary-params';
import {
  colorizeTrancheGroups,
  sortTrancheGroups,
  trancheGroupsToBarGroups
} from './tranche.mapper';

/**
 * Return transformed tranche summary params with issue, orders, tranche, view type
 * and ma them to bar groups with applied filters, sorting and bar group own color.
 *
 * @param  params
 * @returns BarChartData
 */
export function barChartDataMapper(params: TrancheSummaryParams): BarChartData {
  const { deal, orders, tranche, viewType } = params;

  if (!tranche) {
    return undefined;
  }

  const trancheGroup: TrancheGroup = trancheToTrancheGroup(tranche, [tranche]);
  const legends: BarChartLegend[] = getLegendExtractor(viewType)(deal, orders);
  const colorPartExtractor = getColorPartExtractor(legends);

  colorizeTrancheGroups([trancheGroup], colorPartExtractor);
  sortTrancheGroups([trancheGroup], legends);

  return {
    groups: trancheGroupsToBarGroups([trancheGroup]).map(
      (group: BarGroupData) => ({
        ...group,
        bottomLabel: [],
        topLabel: []
      })
    ),
    legend: []
  };
}
